<template>
  <table class="table table-sm results-table">
    <thead>
      <tr>
        <th>{{ $t('shop.results.name') }}</th>
        <th>{{ $t('shop.results.offerColumn') }}</th>
        <th v-if="showOld">
          {{ $t('shop.results.oldScore') }}
        </th>
        <th>{{ showOld ? $t('shop.results.newScore') : $t('shop.results.score') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(row, i) in rows"
        :key="i"
      >
        <td>{{ row.name }}</td>
        <td>{{ row.disciplineName }}</td>
        <td v-if="showOld">
          {{ row.oldScoreDisplay }}
        </td>
        <td>{{ row.newScoreDisplay }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    rows: {
      type: Array,
      required: true,
    },
    showOld: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.results-table {
  th {
    font-size: 0.7rem;
    color: #888;
    font-weight: 600;
    text-transform: uppercase;
    white-space: nowrap;
  }
}
</style>
